"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedUserDetailList = instanceOfPaginatedUserDetailList;
exports.PaginatedUserDetailListFromJSON = PaginatedUserDetailListFromJSON;
exports.PaginatedUserDetailListFromJSONTyped = PaginatedUserDetailListFromJSONTyped;
exports.PaginatedUserDetailListToJSON = PaginatedUserDetailListToJSON;
exports.PaginatedUserDetailListToJSONTyped = PaginatedUserDetailListToJSONTyped;
const userDetail_1 = require("./userDetail");
/**
 * Check if a given object implements the PaginatedUserDetailList interface.
 */
function instanceOfPaginatedUserDetailList(value) {
    if (!('count' in value) || value['count'] === undefined)
        return false;
    if (!('next' in value) || value['next'] === undefined)
        return false;
    if (!('previous' in value) || value['previous'] === undefined)
        return false;
    if (!('results' in value) || value['results'] === undefined)
        return false;
    return true;
}
function PaginatedUserDetailListFromJSON(json) {
    return PaginatedUserDetailListFromJSONTyped(json, false);
}
function PaginatedUserDetailListFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'count': json['count'],
        'next': json['next'],
        'previous': json['previous'],
        'results': (json['results'].map(userDetail_1.UserDetailFromJSON)),
    };
}
function PaginatedUserDetailListToJSON(json) {
    return PaginatedUserDetailListToJSONTyped(json, false);
}
function PaginatedUserDetailListToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': (value['results'].map(userDetail_1.UserDetailToJSON)),
    };
}
//# sourceMappingURL=paginatedUserDetailList.js.map